import script from "./ShowAntragSign.vue?vue&type=script&setup=true&lang=js"
export * from "./ShowAntragSign.vue?vue&type=script&setup=true&lang=js"

import "./ShowAntragSign.vue?vue&type=style&index=0&id=6a6e3b2c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a6e3b2c"]])

export default __exports__